export default __webpack_public_path__ + "static/media/single-deep.3462dcff.png";